import { AxiosError, AxiosResponse } from "axios";
import { DataType, FieldType } from "@websential/cosmic-v20";
import { IGetListRequest, IResponse, IServerError } from "../../models/common";
import {
  IScreenPermissions,
  IScreenPermissionsListPayload,
  IScreenPermissionsResponse,
} from "../../models";

import { GridSize } from "@mui/material";
import http from "../../common/http-commons";

// import { IFixedAndMetaField } from 'common/FlexFieldsUtils';

// import { IVendorListPayload, IVendorRequest, IVendorResponse } from 'models/vendor';
// import { CLIENT_SETUP_FORM, CLIENT_SETUP_FORM_FOR_ADMIN_USER } from 'screensLayoutData/client';

// import { IAPIKeysRequest, IAPIKeysResponse } from '../models';

// import { IScreenPermissionsListPayload, IScreenPermissionsRequest, IScreenPermissionsResponse } from '../models/permissions';

// import { INITIAL_PAGE_SIZE } from 'common/constants';

export const ScreenPermissionsService = {
  getScreenPermissions: async (
    clientId: string,
    data: IGetListRequest,
    navigateToLogout: (path: string) => void
  ): Promise<
    | IScreenPermissionsListPayload
    | IServerError
    | IResponse
    | IScreenPermissionsResponse[]
  > => {
    try {
      const response: AxiosResponse<IScreenPermissionsListPayload> =
        await http.get<IScreenPermissionsListPayload>(
          "/v1/permissions/?order_by=" +
            data.order_by +
            "&order_direction=" +
            data.order_direction +
            "&page=" +
            data.page +
            "&size=" +
            data.size +
            "&search_query=" +
            data.search_query
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getById: async (
    clientId: string,
    id: string | undefined,
    navigateToLogout: (path: string) => void
  ): Promise<IScreenPermissions | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<IScreenPermissions> =
        await http.get<IScreenPermissions>(`/v1/permissions/${id}/`);

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  create: async (
    requestPayload: any
  ): Promise<IScreenPermissions | IServerError | IResponse | any> => {
    // if (requestPayload.id) {
    //   try {
    //     const response: AxiosResponse<IScreenPermissions> =
    //       await http.put<IScreenPermissions>(
    //         `/v1/permissions/${requestPayload.id}/`,
    //         requestPayload
    //       );

    //     if (response.status === 200) {
    //       return response;
    //     } else if (response.status === 400) {
    //       return response.data;
    //     } else if (response.status === 500) {
    //       return {
    //         status: false,
    //         message: "Something went wrong.",
    //         error: true,
    //       };
    //     }
    //   } catch (error) {
    //     const axiosError = error as AxiosError;
    //     console.error("An error occurred:", axiosError);
    //     const errorMessage =
    //       axiosError.response && typeof axiosError.response.data === "string"
    //         ? axiosError.response.data
    //         : "Unknown error";
    //     if (axiosError && axiosError.status === 401) {
    //       requestPayload.navigateToLogout("/logout");
    //       return {
    //         status: false,
    //         message: "UnAuthrized",
    //       };
    //     } else {
    //       return {
    //         status: false,
    //         message: errorMessage,
    //       };
    //     }
    //   }
    // }

    try {
      const response: AxiosResponse<IScreenPermissions> =
        await http.post<IScreenPermissions>(`/v1/permissions/`, requestPayload);

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delScreenPermissions: async (
    delPayload: any
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/permissions/${delPayload.screenPemrissionsId}/`
      );

      if (response.status === 204) {
        return "ScreenPermissions has been deleted successfully";
      } else if (response.status === 200) {
        return "ScreenPermissions has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delBulkScreenPermissionses: async (
    requestPayload: any
  ): Promise<string | IServerError | IResponse> => {
    try {
      const response = await http.delete<string>(`/v1/permissions/`, {
        data: requestPayload.screenPemrissionsIds,
      });
      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getGetScreenPermissionsDDL: async (
    clientId: string
  ): Promise<any | IServerError | IResponse | null> => {
    const response: AxiosResponse<any[]> = await http.get<any[]>(
      `/v1/permissions/ddl`
    );

    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  archiveScreenPermissions: async (
    archivePayload: any
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.post<string>(
        `/v1/permissions/${archivePayload.screenPemrissionsId}/`
      );

      if (response.status === 201) {
        return "ScreenPermissions has been archived successfully";
      } else if (response.status === 200) {
        return "ScreenPermissions has been archived successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        archivePayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
};
